import React, { useEffect } from 'react'
import { Text, csx } from '@vtex/admin-ui'
import { format } from 'date-fns'

import type { OrderForm } from '../../../../../../core/requests/checkout'
import { useCheckout } from '../../../../state'
import { useSalesAssociatesOrderForm } from '../../../../../../core/hooks/useSalesAssociatesOrderForm'

export type OrderFormLastUpdateLabelProps = {
  orderForm: OrderForm
}

export const OrderFormLastUpdateLabel = ({
  orderForm,
}: OrderFormLastUpdateLabelProps) => {
  const { salesAssociatesOrderFormData } = useSalesAssociatesOrderForm({
    where: {
      orderFormId: {
        eq: orderForm?.orderFormId,
      },
    },
  })

  const { checkout, setOrderSummaryUpdateIn } = useCheckout()

  useEffect(() => {
    if (!orderForm) {
      return
    }

    const setLastOrderFormUpdateIn = async () => {
      const salesAssociatesOrderForm = salesAssociatesOrderFormData?.salesAssociatesOrderForms.edges.find(
        (vendorCart) => vendorCart.node.orderFormId === orderForm.orderFormId
      )

      if (salesAssociatesOrderForm?.node.updatedIn) {
        setOrderSummaryUpdateIn(
          (salesAssociatesOrderForm.node.updatedIn as string).toString()
        )
      }
    }

    setLastOrderFormUpdateIn()
  }, [orderForm, setOrderSummaryUpdateIn, salesAssociatesOrderFormData])

  if (!checkout.orderSummary.updatedIn) {
    return null
  }

  return (
    <Text
      variant="title2"
      tone="secondary"
      className={csx({ marginTop: '$space-1' })}
    >
      {format(new Date(checkout.orderSummary.updatedIn), "dd/MM/yyyy HH'h'mm")}
    </Text>
  )
}
